module.exports = __webpack_public_path__ + "static/media/Me.0b641843.JPG";